import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import Confirm from "../../Components/confirm";
import { CommonUtil } from "../../utils/CommonUtil";
import { NetworkManager } from "../../Components/NetworkManager";
import ToastManager from "../../Components/ToastManager";
import ToggleSwitch from "../../Components/ToggleSwitch";
import DraggableComponent from "../../Components/DraggableComponent";
import { Modal } from "react-bootstrap";
import InputField from "../../Components/InputField";
import SelectField from "../../Components/SelectField";
import { default as ReactSelect, components } from "react-select";
import NoDocument from "./NoDocument";
import * as Yup from "yup";
import CreatableReactSelect from "../../Components/CreatableReactSelect";
import ReactSelectField from "../../Components/ReactSelectField";

const DocumentType = ({ unSavedChanges }: any) => {
  const [documents, setDocuments] = useState<any>([]);
  const [getAllDocs, setGetAllDocs] = useState<any>([]);
  const [unSaved, setUnSaved] = useState<boolean>(false);
  const [draggedItem, setDraggedItem] = useState<any>(null);
  const [docTypeId, setDocTypeId] = useState<number | null>(null);
  const [editIndex, setEditIndex] = useState<number | null>(null);
  const [hover, setHover] = useState<number | null>(null);
  const docTypeRef = useRef<HTMLInputElement>(null);
  const sassOrgId = CommonUtil.getSaasOrgId();
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [isInterchange, setIsInterchange] = useState<boolean>(false);
  const [signatureBy, setSignatureBy] = useState<any>([]);
  const signatureAtList = [{label: "Start", value: "Start"}, {label: "End", value: "End"}]

  const onLoginError = (err: any) => {
    console.log(err);
  };

  useEffect(() => {
    getAllDocumentTypes();
  }, []);

  useEffect(() => {
    if(showPopup){
      setSignatureBy([{label: "Driver", value: "Driver"}, {label: "Inspector", value: "Inspector"}, {label: "Security Guard", value: "Security Guard"}])
    }else{
      setSignatureBy([]);
    }
  }, [showPopup]);

  useEffect(() => {
    if(editIndex !== null){    
      const sigBy = [{label: "Driver", value: "Driver"}, {label: "Inspector", value: "Inspector"}, {label: "Security Guard", value: "Security Guard"}];
      const editSignatureBy: any = editFormik.values.signatureBy;
      if(editSignatureBy){
        const combined = [...sigBy, ...editSignatureBy];
        const newSignatureBy = Array.from(new Map(combined.map(item => [item.value, item])).values());
        setSignatureBy(newSignatureBy);
      }else{
        setSignatureBy(sigBy);
      }
    }else{
      setSignatureBy([]);
    }
  }, [editIndex]);

  useEffect(() => {
    console.log("Documents changed:", documents);
    const hasCompareFeatureEnabled = documents.some((item: any) => item.enableCompareFeature === true);
    setIsInterchange(hasCompareFeatureEnabled);
    const isDifferent = JSON.stringify(documents) !== JSON.stringify(getAllDocs);
    setUnSaved(isDifferent && documents.length > 0);
    unSavedChanges(isDifferent && documents.length > 0);
  }, [documents, getAllDocs]);

  const handleDragStart = (event: any, item: any) => {
    setDraggedItem(item);
    event.dataTransfer.effectAllowed = "move";
  };

  const handleDragOver = (event: any) => {
    event.preventDefault();
  };

  const handleDrop = (event: any, targetItem: any) => {
    event.preventDefault();
    if (
      !draggedItem ||
      draggedItem.documentTypesId === targetItem.documentTypesId
    )
      return;

    const updatedList = documents
      .map((item: any) => {
        if (typeof item.sequenceId === "undefined") {
          return { ...item, sequenceId: documents.length + 1 };
        }
        return item;
      })
      .map((item: any) => {
        if (item.documentTypesId === draggedItem.documentTypesId)
          return { ...item, sequenceId: targetItem.sequenceId };

        if (
          draggedItem.sequenceId < targetItem.sequenceId &&
          item.sequenceId > draggedItem.sequenceId &&
          item.sequenceId <= targetItem.sequenceId
        ) {
          return { ...item, sequenceId: item.sequenceId - 1 };
        }
        if (
          draggedItem.sequenceId > targetItem.sequenceId &&
          item.sequenceId < draggedItem.sequenceId &&
          item.sequenceId >= targetItem.sequenceId
        ) {
          return { ...item, sequenceId: item.sequenceId + 1 };
        }
        return item;
      })
      .sort((a: any, b: any) => a.sequenceId - b.sequenceId);

    setDocuments(updatedList);
    setDraggedItem(null);
    updateSequenceAPI(updatedList);
  };

  const updateSequenceAPI = async (updatedList: any) => {
    console.log(updatedList, "updatedList");
    const payload = updatedList.map((item: any, index: any) => ({
      documentTypeName: item.documentTypesName,
      documentTypesId: item.documentTypesId,
      sequenceId: index + 1,
    }));

    const url = `api/v2/config/document-types/sequence?orgId=${sassOrgId}`;
    NetworkManager.sendJsonRequest(url, payload, "", "POST", true, onUpdateSequence, onLoginError);
  };

  const onUpdateSequence = (dataObj: any) => {
    if (dataObj) {
      const restData = JSON.parse(dataObj);
      if (!restData.errorMessage) {
        ToastManager.showToast("Sequence Updated Successfully", "Info");
      }else{
        ToastManager.showToast(restData.errorMessage, "Error");
      }
      getAllDocumentTypes();
    }
  };

  const getAllDocumentTypes = () =>{
    const orgUrl = "api/v2/config/document-types/all/?orgId=" + CommonUtil.getSaasOrgId();
    NetworkManager.sendJsonRequest(orgUrl, "", "", "GET", true, onGetAllSuccess, onLoginError);
  };

  const onGetAllSuccess = (dataObj: any) => {
    if (dataObj) {
      const restData = JSON.parse(dataObj);
      if (restData && restData.length > 0) {
        const updatedData = restData?.map((doc: any) => ({
          ...doc,
          dependentDocTypes: doc.dependentDocTypes?.map((type: any) => {
            return { label: type, value: type };
          }) || [],
          enableCompareFeature: doc.enableCompareFeature || false,
          signatureBy: doc.signatureBy?.map((item: any) => {
            return { label: item, value: item };
          }) || [], 
          signatureAt: doc.signatureAt?.map((item: any) => {
            return { label: item, value: item };
          }) || [],
        }));
        setGetAllDocs(updatedData);
        setDocuments((prevDocuments:any) => [...updatedData]);
      } else {
        setDocuments([]);
      }
    }
  };

  const handleDelete = (docId: any, index: number) => {
    Confirm.show("Confirm", "Would you like to delete this Document Type?", [
      {
        label: "Yes",
        callback: function () {
          if (docId) {
            let docTypeDelAPI = `api/v2/config/document-types/${docId}?orgId=${sassOrgId}`;
            NetworkManager.sendJsonRequest(docTypeDelAPI, "", "", "DELETE", true, (dataObj: any) => {
              if (dataObj) {
                var restData = CommonUtil.parseData(dataObj);
                if (!restData.errorMessage) {
                  ToastManager.showToast("Document Type Deleted Successfully", "Info");
                    setDocuments((prevDocuments: any) =>
                      prevDocuments.filter((_: any, i: number) => i !== index)
                    );
                }else{
                  ToastManager.showToast(restData.errorMessage, "Error");
                }
              }
            }, onLoginError);
          } else {
            setDocuments((prevDocuments: any) =>
              prevDocuments.filter((_: any, i: number) => i !== index)
            );
            ToastManager.showToast("Document Type Removed", "Info");
          }
        },
      },
      { label: "No" },
    ]);
  };

  const getDocumentTypeSchema = (documents: any[], editIndex: number | null) =>
  Yup.object().shape({
    documentTypesName: Yup.string()
      .trim()
      .required('Document Type is required')
      .test(
        'unique-name',
        'Document Type already exists',
        function (value) {
          if (!value) return true;
          const nameToCheck = value.trim().toLowerCase();
          return !documents.some((doc, index) => {
            if (editIndex !== null && index === editIndex) return false;
            return doc.documentTypesName.trim().toLowerCase() === nameToCheck;
          });
        }
      ),
    documentTypesStatus: Yup.string()
      .oneOf(['Active', 'Inactive'], 'Invalid status')
      .required('Status is required'),
    isMultiRelease: Yup.boolean(),
    enableCompareFeature: Yup.boolean(),
    dependentDocTypes: Yup.array().test(
      "dependentDocTypes-required-if-enableCompareFeature",
      "At least one dependent document type is required",
      function (value) {
        const { enableCompareFeature } = this.parent;
        if (enableCompareFeature) {
          return Array.isArray(value) && value.length > 0;
        }
        return true;
      }
    ),
    captureSignature: Yup.boolean(),
    signatureBy: Yup.array().test(
      "signatureBy-required-if-captureSignature",
      "At least one Signature By is required",
      function (value) {
        const { captureSignature } = this.parent;
        if (captureSignature) {
          return Array.isArray(value) && value.length > 0;
        }
        return true;
      }
    ),
    signatureAt: Yup.array().test(
      "signatureAt-required-if-captureSignature",
      "At least one Signature At is required",
      function (value) {
        const { captureSignature } = this.parent;
        if (captureSignature) {
          return Array.isArray(value) && value.length > 0;
        }
        return true;
      }
    ),
    isPartialSubmission: Yup.boolean(),
  });


  const addFormik = useFormik({
    initialValues: {
      documentTypesName: "",
      documentTypesStatus: "",
      isMultiRelease: false,
      signatureBy: [],
      signatureAt: [],
      captureSignature: false,
      captureName: false,
      enableCompareFeature: false,
      dependentDocTypes: [],
      isPartialSubmission: false,
    },
    validationSchema: getDocumentTypeSchema(documents, null),
    onSubmit: (values, { resetForm }) => {
      onSubmitForm(values);
      resetForm();
      setShowPopup(false);
    },
  });

  const editFormik = useFormik({
    initialValues: {
      documentTypesName: "",
      documentTypesStatus: "",
      isMultiRelease: false,
      signatureBy: [],
      signatureAt: [],
      captureSignature: false,
      captureName: false,
      enableCompareFeature: false,
      dependentDocTypes: [],
      isPartialSubmission: false,
    },
    validationSchema: getDocumentTypeSchema(documents, editIndex),
    onSubmit: (values, { resetForm }) => {
      onSubmitForm(values);
      resetForm();
    },
  });
  
  useEffect(() => {
    const resetSignatureFields = (formik: any) => {
      formik.setFieldValue("signatureBy", []);
      formik.setFieldValue("signatureAt", []);
      formik.setFieldValue("captureName", false);
    };

    const resetCompareFields = (formik: any) => {
      formik.setFieldValue("dependentDocTypes", []);
    };

    if (!addFormik.values.captureSignature) {
      resetSignatureFields(addFormik);
    }

    if (!editFormik.values.captureSignature) {
      resetSignatureFields(editFormik);
    }

    if (!addFormik.values.enableCompareFeature) {
      resetCompareFields(addFormik);
    }

    if (!editFormik.values.enableCompareFeature) {
      resetCompareFields(editFormik);
    }
  }, [addFormik.values.captureSignature, editFormik.values.captureSignature, addFormik.values.enableCompareFeature, editFormik.values.enableCompareFeature]);

  const onSubmitForm = (values: any) => {
    const isEdit = editIndex !== null;
    setDocuments((prevDocuments: any) => {
      if (isEdit) {
        return prevDocuments.map((doc: any, index: number) =>
          index === editIndex
            ? {
                ...doc,
                documentTypesName:values.documentTypesName || documents[editIndex].documentTypesName,
                documentTypesStatus:values.documentTypesStatus || documents[editIndex].documentTypesStatus,
                isMultiRelease: values.isMultiRelease === true ? values.isMultiRelease || documents[editIndex].isMultiRelease : false,
                captureSignature: values?.captureSignature === true  ? values?.captureSignature || documents[editIndex].captureSignature : false,
                signatureBy: values?.captureSignature === true ? values?.signatureBy || documents[editIndex].signatureBy : [],
                signatureAt: values?.captureSignature === true  ? values?.signatureAt || documents[editIndex].signatureAt : [],
                captureName: values?.captureName === true  ? values?.captureName|| documents[editIndex].captureName : false,
                enableCompareFeature: values?.enableCompareFeature === true  ? values?.enableCompareFeature || documents[editIndex].enableCompareFeature : false,
                dependentDocTypes: values?.enableCompareFeature === true ? values?.dependentDocTypes || documents[editIndex].dependentDocTypes : [],
                isPartialSubmission: values.isPartialSubmission === true ? values.isPartialSubmission || documents[editIndex].isPartialSubmission : false,
              }
            : doc
        );
      } else {
        const newSequenceId =
          prevDocuments.length > 0 ? Math.max(...prevDocuments.map((d: any) => d.sequenceId || 0)) + 1 
          : 1;

        return [
          ...prevDocuments,
          {
            documentTypesId: null,
            documentTypesName: values.documentTypesName,
            documentTypesStatus: values.documentTypesStatus,
            isMultiRelease: values.isMultiRelease === true ? values.isMultiRelease : false,
            captureSignature: values?.captureSignature === true ? values.captureSignature : false,
            signatureBy: values?.captureSignature === true ? values.signatureBy : [],
            signatureAt: values?.captureSignature === true ? values.signatureAt : [],
            captureName: values?.captureName === true ? values.captureName : false,
            enableCompareFeature: values?.enableCompareFeature === true ? values?.enableCompareFeature : false,
            dependentDocTypes: values?.enableCompareFeature === true ? values.dependentDocTypes : [],
            isPartialSubmission: values.isPartialSubmission === true ? values.isPartialSubmission : false,
            sequenceId: newSequenceId,
            inspectionOrgId: sassOrgId,
            saasOrgId: sassOrgId,
          },
        ];
      }
    });
    if (isEdit) {
      setEditIndex(null);
      setDocTypeId(null);
    }
  };

  const handleBulkSubmit = () => {
    const payload = documents.map((docs: any) => ({
      documentTypesId: docs?.documentTypesId,
      documentTypesName: docs.documentTypesName,
      documentTypesStatus: docs.documentTypesStatus,
      isMultiRelease: docs.isMultiRelease,
      enableCompareFeature: docs.enableCompareFeature || false,
      dependentDocTypes: docs.dependentDocTypes?.map((type: any) => type.value) || [],
      captureSignature: docs.captureSignature || false,
      captureName: docs.captureName || false,
      isPartialSubmission: docs.isPartialSubmission,
      sequenceId: docs.newSequenceId,
      signatureBy: docs.signatureBy?.map((type: any) => type.value) || null,
      signatureAt: docs.signatureAt?.map((type: any) => type.value) || null,
      inspectionOrgId: docs.inspectionOrgId,
      saasOrgId: docs.saasOrgId,
    }));
    console.log("payload", payload)
    const url = `api/v2/config/document-types/bulk?orgId=${sassOrgId}`;
    NetworkManager.sendJsonRequest(url, payload, "", "POST", true, onSubmitSuccess, onLoginError);
  };

  const onSubmitSuccess = (dataObj: any) => {
    if (dataObj) {
      const restData = JSON.parse(dataObj);
      if (!restData?.errorMessage) {
        ToastManager.showToast("Document Type Saved Successfully", "Success");
        setDocuments([]);
      }else{
        ToastManager.showToast(restData.errorMessage, "Error");
      }
      getAllDocumentTypes();
    }
  };

  const handleEdit = (index: number, doc: any) => {
    setEditIndex(index);
    setDocTypeId(doc.documentTypesId);

    editFormik.setValues({
      documentTypesName: doc.documentTypesName,
      documentTypesStatus: doc.documentTypesStatus,
      isMultiRelease: doc.isMultiRelease,
      signatureBy: doc.signatureBy,
      signatureAt: doc.signatureAt,
      captureSignature: doc.captureSignature,
      captureName: doc.captureName,
      enableCompareFeature: doc.enableCompareFeature || false,
      dependentDocTypes: doc.dependentDocTypes || [],
      isPartialSubmission: doc?.isPartialSubmission,
    });
    editFormik.setTouched({})
    editFormik.setErrors({})
  };

  const handleCreateOption = (inputValue: string) => {
    const newOption = { label: inputValue, value: inputValue };
    const updatedOptions = [...signatureBy, newOption];
  
    setSignatureBy(updatedOptions)
  };

  const handleMultiSelect = (selectedOptions: any, key: any, formik: any) => {
    formik.setFieldValue(key, selectedOptions);
  };
  return (
    <>
      <NoDocument>
      <div className={`d-flex align-items-center justify-content-between`}>
        <div className={`col-lg-6 rounded bg-light`}>
          <div className={`d-flex p-3 ${documents.length > 0 ? "d-none" : ""}`}>
            <span>
              <i className="fa fa-info-circle me-3 icon-muted"></i>
            </span>
            <div className="fw-400 text-muted">
              <span className="fw-600 text-dark">
                No Document type added yet
              </span>
              <br></br>
              click "Add New Document Type" to get started
            </div>
          </div>
        </div>
        <div className="col-lg-6 text-end">
        <button type="submit" className="btn btn-success" disabled={isInterchange}
            onClick={()=>{
              addFormik.resetForm();
              setShowPopup(true);
            }}>
            <div className="d-flex justify-content-center align-item-center">
              Add New Document Type
            </div>
          </button>
          <button
            type="submit"
            className="btn btn-dark ms-2"
            onClick={handleBulkSubmit}
            disabled={!unSaved || editIndex !== null}
          >
            <div className="d-flex justify-content-center align-item-center">
              Save
            </div>
          </button>
        </div>
        </div>
        </NoDocument>     
      <div className="col-lg-12" style={{ overflowY: "auto", overflowX: "hidden", height:`${window.innerHeight - 180}px`, padding:"6px 16px"}}>
      {documents.length > 0 && (
        <form onSubmit={editFormik.handleSubmit}>
     
            {documents.map((doc: any, index: any) => (
              <div
                title={unSaved || editIndex !== null ? "" : "Click, Hold, and Drag to set the right sequence"}
                draggable={unSaved || editIndex !== null ? false : true}
                onDragStart={(event) => handleDragStart(event, doc)}
                onDragOver={handleDragOver}
                onDrop={(event) => handleDrop(event, doc)}
                key={doc.documentTypesId}
                className={`row mb-3 pt-4 create-card ${unSaved || editIndex !== null ? "" : ""}`}
                style={{marginLeft: unSaved || editIndex !== null ? "0px drag-icon-empty" : "drag-icon",}}
                onMouseOver={() => setHover(index)}
                onMouseOut={() => setHover(null)}
              >
                <div className="row drag-icon" >
                  <div className="row mb-1 ">
                    <div className="col-md-4">
                      <InputField
                        name="documentTypesName"
                        type="text"
                        className="form-control"
                        placeholder="Document Type"
                        onChange={editFormik.handleChange}
                        value={
                          editIndex === index
                            ? editFormik.values.documentTypesName
                            : doc.documentTypesName
                        }
                        disabled={editIndex !== index}
                      />
                      {editFormik.touched.documentTypesName && editFormik.errors.documentTypesName && editIndex === index && (
                        <small className="ms-2 text-danger fw-700">{editFormik.errors.documentTypesName}</small>
                      )}
                    </div>
                    <div className="col-md-4" style={{position:"relative", marginTop:"1px"}}>
                      <SelectField
                        name="documentTypesStatus"
                        className="form-select"
                        placeholder="Select Status"
                        onChange={editFormik.handleChange}
                        value={
                          editIndex === index
                            ? editFormik.values.documentTypesStatus
                            : doc.documentTypesStatus
                        }
                        disabled={editIndex !== index}
                      >
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                      </SelectField>
                      {editFormik.touched.documentTypesStatus && editFormik.errors.documentTypesStatus && editIndex === index && (
                        <small className="ms-2 text-danger fw-700">{editFormik.errors.documentTypesStatus}</small>
                      )}
                    </div>
                    <div className="col-md-4 d-flex align-items-center">
                      <div className="d-flex p-0 " >
                        <ToggleSwitch 
                          checked={editIndex === index ? editFormik.values.isMultiRelease : doc.isMultiRelease}
                          onChange={(value :any) => editFormik.setFieldValue("isMultiRelease", value)}
                          label="Support Multi-Release"
                          isDisabled={editIndex !== index} />
                        <a className="ms-1 align-self-center">
                          <img 
                          className=" pe-auto" 
                          src={ "./../images/info.svg"} alt="info" width={18} height={18}
                          title="Enabling this option will allow the trailer to be released multiple times before returning the trailer."/>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-4 mb-1 ">
                    <div className="col-md-4 ">
                      <ToggleSwitch 
                        style={{fontSize: "12px"}}
                        checked={editIndex === index ? editFormik.values.enableCompareFeature : doc.enableCompareFeature}
                        onChange={(value: any) => editFormik.setFieldValue("enableCompareFeature", value)}
                        label="Enable Interchange Feature" 
                        isDisabled={editIndex !== index}
                      />
                    </div>
                    <div className="col-md-8 " style={{position:"relative", marginTop:"1px"}}>
                      <CreatableReactSelect
                        isMulti
                        options={[]}
                        name="multiStatus"
                        placeholder="Create new interchange document types"
                        components={{ DropdownIndicator: CustomDropdownIndicator }}
                        onChange={(selected: any) => handleMultiSelect(selected, "dependentDocTypes", editFormik)}
                        value={editIndex === index ? editFormik.values.dependentDocTypes : doc.dependentDocTypes}
                        isDisabled={editIndex !== index || (editIndex === index ? !editFormik.values.enableCompareFeature : !doc.enableCompareFeature)}
                      />
                      {editIndex === index && (editIndex === index ? editFormik.values.enableCompareFeature : doc.enableCompareFeature) ? (
                        editFormik.touched.dependentDocTypes && editFormik.errors.dependentDocTypes ? (
                          <small className="ms-2 text-danger fw-700">{editFormik.errors.dependentDocTypes}</small>
                        ) : (
                          <small className="ms-2 fst-italic">Press enter to add new interchange document types</small>
                        )
                      ) : null}
                    </div>
                  </div>
                  <div className="row mt-4 mb-1 ">
                  <div className="col-lg-6 ">
                    <div className="row">
                    <div className="col-lg-6">
                      <ToggleSwitch style={{fontSize:"12px"}}
                        checked={editIndex === index ? editFormik.values.captureSignature : doc.captureSignature}
                        onChange={(value :any) => editFormik.setFieldValue("captureSignature", value)}
                        label="Capture Signature"
                        isDisabled={editIndex !== index} />
                    </div>
                    <div className="col-lg-6">
                        <ToggleSwitch style={{fontSize:"12px"}}
                            checked={editIndex === index ? editFormik.values.captureName : doc.captureName}
                            onChange={(value :any) => editFormik.setFieldValue("captureName", value)}
                            label="Capture Signee Name"
                            isDisabled={editIndex !== index || (editIndex === index ? !editFormik.values.captureSignature : !doc.captureSignature)} />
                    </div>
                    </div>
                    </div>
                    <div className="col-lg-6 ">
                     <div className="row">
                      <div className="col-lg-6">
                        <CreatableReactSelect
                          placeholder="Signature By"
                          name="signatureBy"
                          isMulti
                          closeMenuOnSelect={false}
                          hideSelectedOptions={false}
                          components={{ MultiValue: CustomMultiValue, Option: CustomOption }}
                          options={[...signatureBy]}
                          value={editIndex === index ? editFormik.values.signatureBy : doc.signatureBy}
                          onChange={(selected: any) => handleMultiSelect(selected, "signatureBy", editFormik)}
                          onCreateOption={handleCreateOption}
                          isDisabled={editIndex !== index || (editIndex === index ? !editFormik.values.captureSignature : !doc.captureSignature)} 
                        />
                        {editIndex === index && (editIndex === index ? editFormik.values.captureSignature : doc.captureSignature) ? (
                          editFormik.touched.dependentDocTypes && editFormik.errors.captureSignature ? (
                            <small className="ms-2 text-danger fw-700">{editFormik.errors.captureSignature}</small>
                          ) : (
                            <small className="ms-2 fst-italic">Type to search options or create new...</small>
                          )
                        ) : null}
                      </div>
                      <div className="col-lg-6">
                        <ReactSelectField placeholder="Signature At" name="signatureAt" 
                          isMulti
                          closeMenuOnSelect={false}
                          hideSelectedOptions={false}
                          options={[...signatureAtList]}
                          onChange={(selected: any) => handleMultiSelect(selected, "signatureAt", editFormik)}
                          value={editIndex === index ? editFormik.values.signatureAt : doc.signatureAt}
                          components={{ MultiValue: CustomMultiValue, Option: CustomOption }}
                          isDisabled={editIndex !== index || (editIndex === index ? !editFormik.values.captureSignature : !doc.captureSignature)}
                        />
                        {editFormik.touched.signatureAt && editFormik.errors.signatureAt && editIndex === index && (
                          <small className="ms-2 text-danger fw-700">{editFormik.errors.signatureAt}</small>
                        )}
                      </div>
                      </div>
                    </div>                 
                  </div>
                   <div className="row mb-3 mt-4 ">                  
                    <div className="col-md-6 me-2">
                      <div className="d-flex ms-1 align-items-center ">
                      <ToggleSwitch style={{fontSize:"12px"}}
                        checked={editIndex === index ? editFormik.values.isPartialSubmission : doc.isPartialSubmission}
                        onChange={(value :any) => editFormik.setFieldValue("isPartialSubmission", value)}
                        label="Allow submission of partially processed documents"
                        isDisabled={editIndex !== index} />
                        <a className="ms-1 align-self-center ">
                          <img className="pe-auto" src={ "./../images/info.svg"} alt="info" width={18} height={18}
                            title="Disabling this will require mobile users to fully complete the documents before posting to the web app." />
                        </a>
                    </div>
                  </div>
                  </div>
                </div>
                <div className="col-md-12 mt-0 text-end ">
                  {editIndex !== index ? (
                  <div className="text-end " style={{ visibility: hover === index ? "visible" : "hidden", }}>
                    <button type="button" title="Edit" className="btn btn-icon" 
                      onClick={(e)=> { e.preventDefault(); handleEdit(index, doc); }} >
                      <img src={ "./../images/edit.svg"} alt="edit" width={18} height={18} />
                    </button>
                    <button type="button" className="btn btn-icon" title="Delete" 
                      onClick={(e)=> { e.preventDefault(); handleDelete(doc.documentTypesId, index); }} >
                      <img src={ "./../images/delete.svg"} alt="delete" width={18} height={18}
                      />
                    </button>
                  </div>
                  ) : (
                  <div className="text-end ">
                    <button type="submit" className="btn btn-icon" title="Save">
                      <img src={ "./../images/check.svg"} alt="check" width={18} height={18}
                      />
                    </button>
                    <button type="button" title="Close" className="btn btn-icon" onClick={()=>
                      setEditIndex(null)} >
                      <img src={ "./../images/cancel.svg"} alt="cancel" width={18} height={18}
                      />
                    </button>
                  </div>
                  )}
                </div>
              </div>
            ))}
          
        </form>
      )}
      <Modal show={showPopup} centered dialogAs={DraggableComponent} id="devEstPopup" size={`xl`}>
        <div className="modal-content new-interchange" id="devEstContentPopup" >
          <Modal.Header className="modal-header" closeButton={false}>
            <h5 className="modal-title mt-0">Add New Document Type</h5>
            <button
              type="button"
              className="isModal"
              data-dismiss="modal"
              style={{ marginLeft: "0px", background: "none" }}
              aria-label="Close"
              onClick={()=>{
                addFormik.resetForm();
                setShowPopup(false);
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </Modal.Header>
          <form onSubmit={addFormik.handleSubmit} className="modal-body">
            <div className="mb-3">
                <div className="row mb-1">
                  <div className="col-md-4">
                    <InputField
                      type="text"
                      autoFocus={true}
                      name="documentTypesName"
                      className="form-control"
                      ref={docTypeRef}
                      placeholder="Document Type"
                      value={addFormik.values.documentTypesName}
                      onChange={addFormik.handleChange}
                      label="Enter Document Type"
                      />
                      {addFormik.touched.documentTypesName && addFormik.errors.documentTypesName && (
                        <small className="ms-2 text-danger fw-700">{addFormik.errors.documentTypesName}</small>
                      )}
                  </div>
                  <div className="col-md-4">
                    <SelectField
                      name="documentTypesStatus"
                      className="form-select"
                      value={addFormik.values.documentTypesStatus}
                      onChange={addFormik.handleChange}
                      placeholder="Status"
                    >
                      <option value="" disabled >Select</option>
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </SelectField>
                    {addFormik.touched.documentTypesStatus && addFormik.errors.documentTypesStatus && (
                      <small className="ms-2 text-danger fw-700">{addFormik.errors.documentTypesStatus}</small>
                    )}
                  </div>
                  <div className="col-md-4 d-flex">
                    <div className="d-flex align-items-center ">
                      <ToggleSwitch style={{fontSize:"12px"}}
                        checked={addFormik.values.isMultiRelease}
                        onChange={(value :any) => addFormik.setFieldValue("isMultiRelease", value)}
                        label="Support Multi-Release" />
                        <a className="ms-1 align-self-center ">
                        <img className="pe-auto" src={ "./../images/info.svg"} alt="info" width={18} height={18}
                          title="Enabling this option will allow the trailer to be released multiple times before returning the trailer." />
                      </a>
                    </div>
                  </div>
              </div>
              <div className="row mt-4 mb-1"  style={{position:"relative", marginTop:"1px", paddingLeft: "8px"}}>
                <div className="col-md-4 d-flex align-items-center">
                  <ToggleSwitch 
                    style={{fontSize: "12px"}}
                    checked={addFormik.values.enableCompareFeature}
                    onChange={(value: any) => addFormik.setFieldValue("enableCompareFeature", value)}
                    label="Enable Interchange Feature" 
                  />
                </div>
                <div className="col-md-7">
                  <CreatableReactSelect
                    options={[]}
                    name="dependentDocTypes"
                    placeholder="Create options..."
                    isMulti
                    components={{ DropdownIndicator: CustomDropdownIndicator }}
                    onChange={(selected: any) => handleMultiSelect(selected, "dependentDocTypes", addFormik)}
                    value={addFormik.values.dependentDocTypes}
                    isDisabled={!addFormik.values.enableCompareFeature}
                  />
                  {addFormik.values.enableCompareFeature ? (
                    addFormik.touched.dependentDocTypes && addFormik.errors.dependentDocTypes ? (
                      <small className="ms-2 text-danger fw-700">{addFormik.errors.dependentDocTypes}</small>
                    ) : (
                      <small className="ms-2 fst-italic">Press enter to add new option</small>
                    )
                  ) : null}
                </div>
              </div>
              <div className="d-flex mb-3 mt-4">
                <div className="ms-2 me-2">
                  <ToggleSwitch style={{fontSize:"12px"}}
                    checked={addFormik.values.captureSignature}
                    onChange={(value :any) => addFormik.setFieldValue("captureSignature", value)}
                    label="Capture Signature" />
                </div>
                <div className={`d-flex`}>
                  <div className={`me-2 ${addFormik.values.captureSignature ? "" : "disable-custom"}`}>
                    <ToggleSwitch style={{fontSize:"12px"}}
                      checked={addFormik.values.captureName}
                      onChange={(value :any) => addFormik.setFieldValue("captureName", value)}
                      label="Capture Signee Name"
                      isDisabled={!addFormik.values.captureSignature} />
                    {/* <TwoLabelToggle/> */}
                  </div>
                  <div className="ms-2 me-1" style={{width: "305px"}}>
                    <CreatableReactSelect
                      placeholder="Signature By"
                      name="signatureBy"
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      components={{ MultiValue: CustomMultiValue, Option: CustomOption }}
                      options={[...signatureBy]}
                      value={addFormik.values.signatureBy}
                      onChange={(selected: any) => handleMultiSelect(selected, "signatureBy", addFormik)}
                      onCreateOption={handleCreateOption}
                      isDisabled={!addFormik.values.captureSignature}
                    />
                    {addFormik.values.captureSignature ? (
                      addFormik.touched.signatureBy && addFormik.errors.signatureBy ? (
                        <small className="ms-2 text-danger fw-700">{addFormik.errors.signatureBy}</small>
                      ) : (
                        <small className="ms-2 fst-italic">Type to search options or create new...</small>
                      )
                    ) : null}
                  </div>
                  <div className="ms-4" style={{width: "299px"}}>
                    <ReactSelectField placeholder="Signature At" name="signatureAt" className="form-select" 
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      components={{ MultiValue: CustomMultiValue, Option: CustomOption }}
                      value={addFormik.values.signatureAt}
                      options={[...signatureAtList]}
                      onChange={(selected: any) => handleMultiSelect(selected, "signatureAt", addFormik)}
                      isDisabled={!addFormik.values.captureSignature}
                    />
                    {addFormik.touched.signatureAt && addFormik.errors.signatureAt && (
                      <small className="ms-2 text-danger fw-700">{addFormik.errors.signatureAt}</small>
                    )}
                  </div>
                </div>
              </div>
              <div className={` d-flex mb-3 mt-4`}>
                <div className="col-md-6 ms-2 me-2 d-flex">
                  <div className="d-flex align-items-center ">
                    <ToggleSwitch style={{fontSize:"12px"}}
                      checked={addFormik.values.isPartialSubmission}
                      onChange={(value :any) => addFormik.setFieldValue("isPartialSubmission", value)}
                      label="Allow submission of partially processed documents" />
                    <a className="ms-1 align-self-center ">
                      <img className="pe-auto" src={ "./../images/info.svg"} alt="info" width={18} height={18}
                        title="Disabling this will require mobile users to fully complete the documents before posting to the web app." />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12 d-flex justify-content-end align-items-end">
              <button type="submit" className="btn btn-dark"
              ><i className="fa-solid fa-plus me-1 mt-1"></i>
                <span>Add</span>
              </button>
              <button
                type="button"
                className="btn btn-outline-light ms-1"
                onClick={() => {
                  addFormik.resetForm();
                  setShowPopup(false);
                }}
              >Cancel
              </button>
            </div>
          </form>
          </div>
        </Modal>
      </div>
    </>
  );
};
const CustomMultiValue = ({ data, index, selectProps }: any) => {
  const selectedValues = selectProps.value || [];
  if (index !== 0) return null;

  const visibleCount = 2;
  const visibleLabels = selectedValues.slice(0, visibleCount).map((item: any) => item.label);
  const remainingCount = selectedValues.length - visibleCount;

  return (
    <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
      <span>{visibleLabels.join(",  ")}</span>
      {remainingCount > 0 && (
        <span className="count-badge" style={{ marginLeft: 5 }}>
          +{remainingCount}
        </span>
      )}
    </div>
  );
};

const CustomDropdownIndicator = () => null;

const CustomOption = (props: any) => {
  return (
    <components.Option {...props}>
      <input
        type="checkbox"
        checked={props.isSelected}
        onChange={() => null}
      />
      <label style={{ marginLeft: "8px" }}>{props.label}</label>
    </components.Option>
  );
};
export default DocumentType;
